import { useQuery } from "@tanstack/react-query";
import i18next from "i18next";
import { get } from "lodash";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { GamePlayerApi } from "states/api/gamePlayer";
import { formatNumber } from "_common/utils/formatValue";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronRight,
  faLongArrowAltLeft,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

export default function DataDetail({ item, onGetDetail }) {
  const navigate = useNavigate();

  return (
    <>
      <div className="no_headers relative">
        <span
          className="btn_back absolute left-[10px] translate-y-[50%]"
          onClick={() => onGetDetail()}
        >
          <FontAwesomeIcon icon={faLongArrowAltLeft} color="#707A8A" />
        </span>
        <div className="infotbox text-center">
          <b className="text-[24px] text-[#00b897] text-uppercase">
            {item?.game?.name} Chi tiết hợp đồng
          </b>
        </div>
      </div>
      <div className="infobox">
        <div className="lbox">
          <div className="lbox_l">
            <span className="fe6im fzmm">Giá trị hợp đồng</span>
          </div>
          <div className="lbox_r">
            <span className="fe6im fzmmm">
              {formatNumber(item?.amount, "0,0.[0000000]")}USDT
            </span>
          </div>
        </div>
        <div className="lbox">
          <div className="lbox_l">
            <span className="fe6im fzmm">Thời hạn hợp đồng</span>
          </div>
          <div className="lbox_r">
            <span className="fe6im fzmmm">{formatNumber(item?.type)}s</span>
          </div>
        </div>
        <div className="lbox">
          <div className="lbox_l">
            <span className="fe6im fzmm">Loại hợp đồng</span>
          </div>
          <div className="lbox_r">
            <span
              className={`fzmmm text-[#0ecb81] ${
                item?.bet_game === "sell" && "text-[#f5465c]"
              }`}
            >
              {i18next.t(item?.bet_game)}
            </span>
          </div>
        </div>
        <div className="lbox">
          <div className="lbox_l">
            <span className="fe6im fzmm">Tình trạng hợp đồng</span>
          </div>
          <div className="lbox_r">
            <span className="fe6im fzmm">
              {item?.status === "bet" ? "Đang tiến hành" : "Đã thanh toán"}
            </span>
          </div>
        </div>
        <div className="lbox">
          <div className="lbox_l">
            <span className="fe6im fzmm">Giá mở lệnh</span>
          </div>
          <div className="lbox_r">
            <span className="fe6im fzmm">
              {formatNumber(item?.open, "0,0.[0000000]")}
            </span>
          </div>
        </div>
        <div className="lbox">
          <div className="lbox_l">
            <span className="fe6im fzmm">Thiết lập thời gian</span>
          </div>
          <div className="lbox_r">
            <span className="fe6im fzmm">
              {moment(item?.created_at).format("YYYY-MM-DD HH:mm:ss")}
            </span>
          </div>
        </div>
        <div className="lbox">
          <div className="lbox_l">
            <span className="fe6im fzmm">Thời gian định vị</span>
          </div>
          <div className="lbox_r">
            <span className="fe6im fzmm">
              {moment(item?.updated_at).format("YYYY-MM-DD HH:mm:ss")}
            </span>
          </div>
        </div>
        <div className="lbox">
          <div className="lbox_l">
            <span className="fe6im fzmm">Lợi nhuận và thua lỗ</span>
          </div>
          <div className="lbox_r">
            {item?.status === "win" && (
              <span className="text-[#0ecb81]">
                {formatNumber(item?.amount_payback, "0,0.[000000]")}USDT
              </span>
            )}
            {item?.status === "lose" && (
              <span className="text-[#f5465c]">
                -{formatNumber(item?.amount_lose, "0,0.[000000]")}USDT
              </span>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
